module.exports = __webpack_public_path__ + "img/home-production-03.dc60e001.png";